import { render } from "./YTPlayer.vue?vue&type=template&id=71b1f406"
import script from "./YTPlayer.vue?vue&type=script&lang=js"
export * from "./YTPlayer.vue?vue&type=script&lang=js"

import "./YTPlayer.vue?vue&type=style&index=0&id=71b1f406&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__